/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";

// Carregamento direto das fontes MDI sem preload para evitar problemas
const loadFonts = () => {
  // Em vez de usar preload que está causando avisos, vamos apenas garantir
  // que o CSS do MDI seja carregado corretamente
  
  // Verificar se estamos em ambiente de produção ou desenvolvimento
  const isProd = import.meta.env.PROD;
  
  // Adicionar um link para o CSS do MDI caso ainda não exista
  const cssLink = document.querySelector('link[href*="materialdesignicons"]');
  if (!cssLink) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = isProd ? '/jodarc/assets/mdi-font.css' : '/fonts/mdi/mdi-font.css';
    document.head.appendChild(link);
  }
};

// Executar o carregamento das fontes quando o documento estiver pronto
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadFonts);
  } else {
    loadFonts();
  }
}
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import { pt } from "vuetify/locale";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  locale: {
    locale: "pt",
    fallback: "en",
    messages: { pt },
  },

  // Configuração dos breakpoints
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#1867C0",
          secondary: "#5CBBF6",
          accent: "#82B1FF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
    },
  },

  defaults: {
    VCard: {
      elevation: 2,
    },
    VBtn: {
      variant: 'elevated',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
});
